import { FormattedHTMLMessage, injectIntl } from "react-intl";

import { getFieldConfigByFieldId } from "@/lib/utils/stepComponentHelpers/stepComponentHelpers";

import { type FormFieldComponentProps } from "../../../lib/types/types";
import { FormFieldText } from "../FormFieldText/FormFieldText";

export const FirstName = ({
  value,
  isErrored,
  onChange,
  intl,
  placeholder = "",
  disabled = false,
}: FormFieldComponentProps) => {
  const isFieldHidden = getFieldConfigByFieldId("firstName")?.hidden;

  if (isFieldHidden) {
    return null;
  }

  return (
    <FormFieldText
      fieldId="firstName"
      autoComplete="given-name"
      value={value}
      onChange={onChange}
      placeholder={
        placeholder ||
        intl.formatHTMLMessage({ id: "firstNamePlaceholder", defaultMessage: "First Name" })
      }
      label={<FormattedHTMLMessage id="firstName" defaultMessage="First name" />}
      errorMessage={
        isErrored && (
          <FormattedHTMLMessage id="errorId.invalidFirstName" defaultMessage="Invalid first name" />
        )
      }
      showPlaceholderAndHideLabel={!!placeholder}
      disabled={disabled}
    />
  );
};
export const FirstNameComponent = injectIntl(FirstName);
